import axios from "axios";
import router from "../../router/index"
import { getToken, clearToken,getPermissions } from "../../utils/index";
import { message } from "ant-design-vue";

const GoLogin = () => {
  clearToken();
  router.push("/sign-in");
};

const GoError = () => {
  window.location.href = "/error";
};

class HttpClient {
  constructor(url) {
    this.axios = axios.create({
      baseURL: url,
      timeout: 15000,
      withCredentials: false,
      headers: {
        Accept: "application/json",
      },
    });


    this.axios.interceptors.request.use(
        (config) => {
          const token = getToken();
          const permission = getPermissions()
          if(token && permission == 'admin'){
            config.headers.Token = token
          }else{
            router.push("/sign-in");
          }
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      
  
  

    this.axios.interceptors.response.use(
      (response) => {
        let code = response.data.status; //业务返回代码
        let msg = response.data.message; //错误消息

        if (code === 200) {
          return Promise.resolve(response);
        } if (code === -1)  {
            message.error(msg);
        }
        if (code == 401) {
          GoLogin();
          message.error("请重新登录");
          return Promise.reject(response); // 直接 reject 掉这个 response
        } 
      },
      // 当http的状态码非0
      (error) => {
        let status = error.response.status;
        if (status === 404) {
          // 跳转到404页面
          GoError();
        } else if (status === 403) {
          // 跳转到无权限页面
          GoError();
        } else if (status === 500) {
          // 跳转到500异常页面
          GoError();
        }else if (status === 40) {
          // 跳转到500异常页面
          message.error("请求错误");
        }
        return Promise.reject(error.response);
      }
    );
  }

  get(url, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .get(url, {
          params: params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

  destroy(url) {
    return new Promise((resolve, reject) => {
      this.axios
        .delete(url)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

  post(url, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .post(url, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

  put(url, params) {
    return new Promise((resolve, reject) => {
      this.axios
        .put(url, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }

  request(config) {
    return new Promise((resolve, reject) => {
      this.axios
        .request(config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  }
}

const APP_URL = process.env.VUE_APP_URL || ""; // 根据你的环境配置获取应用 URL

const client = new HttpClient(APP_URL);

export default client;
